module.exports = __webpack_public_path__ + "img/productive-unproductive-summary.21db5bce.webp";